import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function NavigationScrollReset() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll(".main-panel").forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
